import React from 'react';
import SharedWithFDADisclaimer from './SharedWithFDADisclaimer';
import SkeletonWrapper from './skeleton/SkeletonWrapper';

/**
 * @typedef {object} PageInstructionsProps
 * @property {string} [title]
 * @property {React.ReactNode} [description]
 * @property {boolean} [fdaShareWarning]
 * @property {boolean} [loading]
 * @property {string} [skeletonClassName]
 */

/**
 * @param {PageInstructionsProps} props
 */
const PageInstructions = props => {
  const { title, description, fdaShareWarning = false, loading = false, skeletonClassName } = props;
  return (
    <SkeletonWrapper show={loading} skeletonClassName={skeletonClassName} inheritParentSize>
      <div data-testid='page-instructions' role='pageInstructions' className='page-description'>
        <p className='page-description__title'>{title}</p>
        <span className='page-description__summary'>{description}</span>
        {fdaShareWarning && <SharedWithFDADisclaimer />}
      </div>
    </SkeletonWrapper>
  );
};

export default PageInstructions;
